// extracted by mini-css-extract-plugin
export default {"container":"RecentlyAddedBooks_container__AAMp9","tab-body":"RecentlyAddedBooks_tab-body__PUGi6"};